import React, { useEffect, useState } from "react";
import {
  CustomSelect,
  getData,
  postData,
} from "../Commonfunction/CommonFunction";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import ExcelJS from "exceljs";
import logo from "../../assets/images/mainLogo.png";
import { saveAs } from "file-saver";
import { Field, Form, Formik } from "formik";
import CommonModal from "../common/CommonModal";
import CurrencyFormat from "react-currency-format";
import "../../assets/style/AddPrivousMonthTax.css";

export default function AddPrivousMonthTax({
  id,
  onClose,
  filter,
  isDwonload = false,
}) {
  const userType = localStorage.getItem("user_type");
  const location = useLocation();
  const [singleData, setSingleData] = useState();
  const [monthByYear, setMonthByYers] = useState([]);
  const [monthSingleFileData, setMonthSingleFileDate] = useState();

  const [commanFiled, setCommanFiled] = useState("");
  const [commanFiledLabel, setCommanFiledLabel] = useState("");
  const [commanFiledModal, setCommanFiledModal] = useState(false);

  const [submitLoader, setSubmitLoader] = useState(false);
  const formatString = (str) => str.replace(/_/g, " ");
  const singleCountyData = async () => {
    try {
      const request_url = location.pathname.includes("view-customer-file")
        ? `/api/get-customer-file/${id}`
        : `/api/get-customer-file-by-customer-id/${id}`;
      const result = await getData(request_url);
      if (result.success) {
        setSingleData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const validationSchemaDisapproveModal = Yup.object().shape({
    year: Yup.string().required("Year is required"),
    month: Yup.string().required("Month is required"),
  });

  const validationSchemaFilterModal = Yup.object().shape({
    year: Yup.string().required("Year is required"),
    filter_type: Yup.string().required("Filter type is required"),
  });
  const handleSubmit = async (FinalValue) => {
    // console.log('FinalValue---', FinalValue)
    // return false
    try {
      const request_url = `/api/add-client-previous-data/${id}`;
      const postDataResult = await postData(request_url, FinalValue);
      toast.success(postDataResult.message);
      onClose();
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  const [currentMonth, setCurrentMonth] = useState("");

  useEffect(() => {
    const month = new Date().toLocaleString("default", { month: "long" });
    setCurrentMonth(month);
    !filter && singleCountyData();
  }, []);
  const yearOptions = Array.from({ length: 20 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return { value: year.toString(), label: year };
  });
  const monthOptions = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const filterOptions = [
    { value: "q1", label: "Quater 1" },
    { value: "q2", label: "Quater 2" },
    { value: "q3", label: "Quater 3" },
    { value: "q4", label: "Quater 4" },
    { value: "h1", label: " H 1" },
    { value: "h2", label: "H 2" },
    { value: "annual", label: "Annually" },
  ];

  const downloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = async (data) => {
    try {
      const result = await postData(
        `/api/tax-calculation-report-export/${id}`,
        data
      );
      if (result) {
        const fileUrl = result.url;
        downloadFile(fileUrl);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const handleDownload2 = async (data) => {
    setSubmitLoader(true);
    try {
      //($year, $filter_type, $id)
      const result = await postData(
        `/api/tax-calculation-report-export-compile/${id}`,
        data
      );
      if (result) {
        // const fileUrl = result.url;
        // console.log('fileUrl---', result)
        let { customerdata, taxhead, ...qtyOne } = result;
        // let { customerdata, taxhead, ...qtyOne } = singleXYX;
        const updatedQtyOneData = removeMainObject(qtyOne, customerdata);
        console.log("updatedQtyOneData", updatedQtyOneData);
        await generateExcel(customerdata, updatedQtyOneData, data, result);
        onClose();
        setSubmitLoader(false);
        // downloadFile(fileUrl);
      }
    } catch (error) {
      console.log("Error: ", error);
      onClose();
      setSubmitLoader(false);
    }
  };

  function removeMainObject(data, customerdata) {
    const businessTypeHandlers = {
      default: (monthData, calculationTotal) => {
        if (calculationTotal?.["Gross_sale"] !== undefined) {
          return {
            Gross_sale: {
              Gross_sale: calculationTotal["Gross_sale"],
              // Gross_Taxable_Sales: calculationTotal["Gross_Taxable_Sales"],
            },
            ...monthData,
          };
        }
        return monthData;
      },
    };

    for (const month in data) {
      if (data[month]?.hasOwnProperty("Calculation_Total")) {
        const calculationTotal = data[month]["Calculation_Total"];
        let updatedMonthData = { ...data[month] };

        const handler = businessTypeHandlers["default"];
        updatedMonthData = handler(updatedMonthData, calculationTotal);

        // Remove "Main" if exists
        if (updatedMonthData.hasOwnProperty("Main")) {
          delete updatedMonthData["Main"];
        }

        // Process each category
        for (const category in updatedMonthData) {
          const currentObj = updatedMonthData[category];

          if (
            ["Gas", "Diesel", "Other"].includes(category) &&
            currentObj?.hasOwnProperty("Total")
          ) {
            delete currentObj["Total"];
          }

          if (
            category === "Calculation_Total" &&
            currentObj?.hasOwnProperty("Gross_sale")
          ) {
            delete currentObj["Gross_sale"];
            delete currentObj["Gross_Taxable_Sales"];
            delete currentObj["Total_Gas_Diesel_gallon"];
            delete currentObj["Total_Gas_Diesel_sale"];
            delete currentObj["Total_Gas_Diesel_sale_MIn"];
          }

          // Move Total to end (for all except Hotel_Occupancy and Room_Tax which are handled separately)
          if (
            currentObj?.hasOwnProperty("Total")
            //  &&
            // category !== "Hotel_Occupancy" &&
            // category !== "Room_Tax"
          ) {
            const totalValue = currentObj["Total"];
            delete currentObj["Total"];
            currentObj["Total"] = totalValue;
          }

          if (currentObj?.hasOwnProperty("Total_Amount_Due")) {
            currentObj["Final_Total_Amount_Due"] =
              currentObj["Total_Amount_Due"];
          }

          // Move Total to start in Hotel_Occupancy
          // if (category === "Hotel_Occupancy" && currentObj?.hasOwnProperty("Total")) {
          //   const { Total, ...rest } = currentObj;
          //   updatedMonthData[category] = {
          //     Total,
          //     ...rest,
          //   };
          // }

          // // Move Total to start in Room_Tax
          // if (category === "Room_Tax" && currentObj?.hasOwnProperty("Total")) {
          //   const { Total, ...rest } = currentObj;
          //   updatedMonthData[category] = {
          //     Total,
          //     ...rest,
          //   };
          // }
        }

        // Move GA_Tax to the start of the object
        const reorderedData = {};
        if (updatedMonthData["GA_Tax"]) {
          reorderedData["GA_Tax"] = updatedMonthData["GA_Tax"];
          delete updatedMonthData["GA_Tax"];
        }
        data[month] = {
          ...reorderedData,
          ...updatedMonthData,
        };
      }
    }

    return data;
  }
  const generateExcel = async (customerdata, qtyOne, data, result) => {
    console.log("*****===>", result);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Report");

    const STYLES = {
      COLORS: {
        header: "4472C4", // Blue for headers (as in image)
        subheader: "8EA9DB", // Lighter blue for subheaders
        highlight: "FFD966", // Soft yellow for highlights
        altRow1: "F2F2F2", // Light gray for alternating rows (as in image)
        altRow2: "FFFFFF", // White for alternating rows
        total: "E2EFDA", // Light green for totals
        title: "2F528F", // Dark blue for title text
        border: "D9D9D9", // Medium gray for borders
        warning: "FF0000", // Red for critical values
        black: "000000",
        white: "FFFFFF",
        labelBg: "1F4E78", // Darker blue for label backgrounds (as in image)
        valueBg: "DCE6F1", // Very light blue for value backgrounds (as in image)
        tableBorder: "4472C4", // Blue for table borders (as in image)
        thinBorder: "D0D0D0", // Light gray for thin borders
        gridHeaderBg: "4472C4", // Blue for grid headers (as in image)
        gridSubheaderBg: "4472C4", // Light blue for grid subheaders (as in image)
        infoHeaderBg: "4472C4", // Matching header blue for info sections
        netSalesHighlight: "", // Pink highlight for NET_SALES
      },
      FONTS: {
        header: { bold: true, size: 12, color: { argb: "FFFFFF" } },
        subheader: { bold: true, size: 11 },
        normal: { size: 10, name: "Calibri" },
        bold: { bold: true, size: 10, name: "Calibri" },
        title: { bold: true, size: 14, color: { argb: "2F528F" } },
        label: { bold: true, size: 10, color: { argb: "FFFFFF" } },
        whiteText: { size: 10, color: { argb: "FFFFFF" } },
        netSalesFont: { bold: true, size: 10, color: { argb: "#000" } }, // Bold red text for NET_SALES
      },
      HIGHLIGHT_KEYS: {
        totalRows: new Set([
          "Total",
          "NET_SALES",
          "Total_Gross",
          "Gross_Non_fuel_sale",
          "Final_Total_Amount_Due",
          "Total_Amount_Due",
          "Adjustment",
        ]),
        important: new Set([
          "High_Net_Taxable",
          "High_Sales_Tax",
          "Low_Tax_Net_Taxable",
          "Low_Tax_Sales_Tax",
          "Food_Net_Sales",
          "State_Food_Tax",
          "Non_Food_Net_Food",
          "State_Non_Food_Tax",
          "Local_Sale_Net_Tax",
          "Local_Sale_Tax",
          "CBD_Net_Sales_$",
          "CBD_Sales_Tax",
          "Education_Tax",
          "Local_Sale_Tax_1",
          "Exempt_Trans",
          "Adjustment",
          "NET_SALES",
          "Total_Due",
        ]),
      },
      SECTION_ORDER: [
        "Gross_sale",
        "GA_Tax",
        "Hotel_Occupancy",
        "Room_Tax",
        "High",
        "Low",
        "Non_Taxable",
        "Gas",
        "Diesel",
        "Non_Food",
        "Food_Sales",
        "CBD_Sales",
        "Non_Taxable_Sales",
        "Lotto_&_Non_Sales",
        "Other_Misc_Info",
      ],
    };

    worksheet.columns = [
      { width: 5 }, // A - Blank column
      { width: 25 }, // B - Labels column (wider)
      { width: 13 }, // C
      { width: 13 }, // D
      { width: 13 }, // E
      { width: 13 }, // F
      { width: 13 }, // G
      { width: 13 }, // H
      { width: 13 }, // I
      { width: 13 }, // J
      { width: 13 }, // K
      { width: 13 }, // L
      { width: 13 }, // M
      { width: 13 }, // N
      { width: 13 }, // O
      { width: 13 }, // P
      { width: 13 }, // Q
      { width: 13 }, // R
      { width: 13 }, // S
    ];

    const applyStyle = (cell, styleType, align = "left") => {
      const { COLORS, FONTS } = STYLES;

      cell.alignment = { horizontal: align, vertical: "middle" };
      cell.border = {
        top: { style: "thin", color: { argb: COLORS.thinBorder } },
        left: { style: "thin", color: { argb: COLORS.thinBorder } },
        bottom: { style: "thin", color: { argb: COLORS.thinBorder } },
        right: { style: "thin", color: { argb: COLORS.thinBorder } },
      };

      switch (styleType) {
        case "header":
          cell.font = FONTS.header;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.header },
          };
          break;
        case "gridHeader":
          cell.font = FONTS.header;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.gridHeaderBg },
          };
          break;
        case "gridSubheader":
          cell.font = FONTS.whiteText;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.gridSubheaderBg },
          };
          break;
        case "subheader":
          cell.font = FONTS.subheader;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.subheader },
          };
          break;
        case "title":
          cell.font = FONTS.title;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.white },
          };
          break;
        case "total":
          cell.font = FONTS.bold;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.total },
          };
          break;
        case "highlight":
          cell.font = FONTS.bold;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.highlight },
          };
          break;
        case "netSalesHighlight":
          cell.font = FONTS.netSalesFont;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.netSalesHighlight },
          };
          break;
        case "alternate":
          cell.font = FONTS.normal;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: align === "even" ? COLORS.altRow1 : COLORS.altRow2,
            },
          };
          break;
        case "label":
          cell.font = FONTS.label;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.labelBg },
          };
          break;
        case "infoHeader":
          cell.font = FONTS.label;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.infoHeaderBg },
          };
          break;
        case "value":
          cell.font = FONTS.normal;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: COLORS.valueBg },
          };
          break;
        default:
          cell.font = FONTS.normal;
      }

      return cell;
    };

    const setCellValue = (
      cellRef,
      value,
      styleType = "value",
      align = "left",
      formatAsCurrency = true
    ) => {
      const cell =
        typeof cellRef === "string" ? worksheet.getCell(cellRef) : cellRef;

      cell.value = value;
      applyStyle(cell, styleType, align);

      if (
        (formatAsCurrency && typeof value === "number") ||
        (typeof value === "string" && !isNaN(parseFloat(value)))
      ) {
        cell.numFmt = '"$ "#,##0.00';
      }

      return cell;
    };

    try {
      // Logo and Header
      worksheet.mergeCells("B1:S5");
      const logoCell = worksheet.getCell("B1");
      logoCell.value = " ";
      logoCell.alignment = { vertical: "center", horizontal: "center" };

      if (logo) {
        const response = await fetch(logo);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({
          buffer: imageBuffer,
          extension: "png",
        });

        worksheet.addImage(imageId, {
          tl: { col: 7, row: 0 }, // Centered position as in image (shifted right by 1)
          ext: { width: 255, height: 90 }, // Adjusted size
        });
      }

      for (let col = 2; col <= 19; col++) {
        // Shifted right by 1
        worksheet.getCell(5, col).border = {
          bottom: {
            style: "medium",
            color: { argb: STYLES.COLORS.tableBorder },
          },
        };
      }

      // Title - Year and Report Type
      worksheet.mergeCells("B6:E6");
      const titleCell = worksheet.getCell("B6");
      titleCell.value = `${data?.year} ${data?.filter_type?.toUpperCase() || "ANNUAL"
        } REPORT`;
      titleCell.font = { ...STYLES.FONTS.title, size: 12 }; // Adjusted to match image
      titleCell.alignment = { horizontal: "left", vertical: "middle" };

      // Merge cells C and D from row 7 to row 14
      for (let row = 7; row <= 14; row++) {
        worksheet.mergeCells(`D${row}:E${row}`);
      }

      // Customer Information Section
      // Match the blue background color for headers
      const infoHeaders = [
        [ "C7", "COMPANY" ],
        [ "C8", "DBA" ],
        [ "C9", "Address Line 1" ], // Changed to match image
        [ "C10", "Address Line 2" ], // Changed to match image
        [ "C11", "City/ State" ],
        [ "C13", "S&U Number" ],
        [ "C14", "Year" ],
        [ "G8", "High" ],
        [ "G9", "County" ],
        [ "G10", "Total State" ],
        [ "M8", "Vand Comp-1St" ],
        [ "M9", "Vand Comp-Aft" ],
        [ "M10", "On Road Fuel" ],
        [ "M11", "Off Road Fuel" ],
        [ "M7", "Discount Name" ],
        [ "J7", "Tax Name" ],
        [ "K7", "Tax Rate" ],
        [ "G7", "Tax Name" ],
        [ "H7", "Tax Rate" ],
        [ "N7", "Tax Amount" ],
        [ "O7", "Tax Rate" ],
        [ "Q7", "Contact" ],
        [ "Q8", "Email" ],
        [ "Q9", "Phone No." ],
        [ "Q10", "EIN" ],
      ];

      infoHeaders.forEach(([ cell, value ]) =>
        setCellValue(cell, value, "infoHeader", "center")
      );

      const customerInfoValues = [
        [ "D7", customerdata?.customerinner?.company_name ],
        [ "D8", customerdata?.customerinner?.dba_name ],
        [ "D9", customerdata?.customerinner?.street_1 ],
        [ "D10", customerdata?.customerinner?.street_2 ],
        [ "D11", `${customerdata?.city}/ ${customerdata?.state}` ],
        [ "D14", data?.year ],
        [ "D13", customerdata?.customerinner?.s_and_u_number ],
        [ "H8", `${customerdata?.high_tax} %` ],
        [ "H9", `${customerdata?.county_tax} %` ],
        [ "H10", `${customerdata?.total_tax} %` ],
        [ "N8", customerdata?.vendor_comp_above_tax ],
        [ "N9", customerdata?.vendor_comp_below_tax ],
        [ "O8", `${customerdata?.vendor_comp_above} %` ],
        [ "O9", `${customerdata?.vendor_comp_below} %` ],
        [ "N10", `${customerdata?.on_road_fuel} %` ],
        [ "N11", `${customerdata?.off_road_fuel} %` ],
        [ "R7", customerdata?.customerinner?.landline_no ],
        [ "R8", customerdata?.customerinner?.email ],
        [ "R9", customerdata?.customerinner?.mobile_no ],
        [ "R10", customerdata?.customerinner?.ein_number ],
      ];

      customerInfoValues.forEach(([ cell, value ]) => {
        const cellObj = setCellValue(cell, value, "value");
        if (
          typeof value === "number" ||
          (typeof value === "string" && !isNaN(parseFloat(value)))
        ) {
          cellObj.alignment = { horizontal: "center", vertical: "middle" };
        } else {
          cellObj.alignment = { horizontal: "center", vertical: "middle" };
        }
      });

      // Tax information sections with updated colors to match the image
      const hotelTaxLabels = [
        [ "J8", "Occup. Tax" ],
        [ "M12", "Occup. Credit" ],
        [ "J9", "Per Room tax" ],
      ];

      const hotelTaxValues = [
        [ "K8", `${customerdata?.occup_tax} %` ],
        [ "N12", `${customerdata?.occup_credit} %` ],
        [ "K9", `$ ${customerdata?.per_room_tax}` ],
      ];

      const foodnonfoodTaxLabels = [
        [ "G11", "Food Sales" ],
        [ "G12", "Non Food" ],
        [ "G13", "Local Tax" ],
        [ "J10", "CBD Sales" ],
        [ "J11", "Local Tax1" ],
        [ "J12", "Education Tax" ],
        [ "J13", "Use Tax" ],
      ];

      const foodnonfoodTaxValues = [
        [ "H11", `${customerdata?.food_sales} %` ],
        [ "H12", `${customerdata?.non_food} %` ],
        [ "H13", `${customerdata?.local_tax}` ],
        [ "K10", `${customerdata?.cbd_sales} %` ],
        [ "K11", `${customerdata?.local_tax_1} %` ],
        [ "K12", `${customerdata?.education_tax} %` ],
        [ "K13", `0.00 %` ],
      ];

      hotelTaxLabels.forEach(([ cell, value ]) =>
        setCellValue(cell, value, "infoHeader", "center")
      );
      hotelTaxValues.forEach(([ cell, value ]) => {
        const cellObj = setCellValue(cell, value, "value");
        cellObj.alignment = { horizontal: "center", vertical: "middle" };
      });

      foodnonfoodTaxLabels.forEach(([ cell, value ]) =>
        setCellValue(cell, value, "infoHeader", "center")
      );
      foodnonfoodTaxValues.forEach(([ cell, value ]) => {
        const cellObj = setCellValue(cell, value, "value");
        cellObj.alignment = { horizontal: "center", vertical: "middle" };
      });

      // Bank Info Section
      worksheet.mergeCells("Q12:S12");
      setCellValue("Q12", "Bank Info", "infoHeader", "center");
      for (let i = 7; i <= 10; i++) {
        worksheet.mergeCells(`R${i}:S${i}`);
      }
      for (let i = 13; i <= 15; i++) {
        worksheet.mergeCells(`R${i}:S${i}`);
      }
      const bankSection = [
        [ "Q13", "Bank Name", "R13", customerdata?.bank_name ],
        [ "Q14", "A/C", "R14", customerdata?.bank_account_no ],
        [ "Q15", "Routing", "R15", customerdata?.customerinner?.routing_number ],
      ];

      bankSection.forEach(([ labelCell, labelText, valueCell, value ]) => {
        setCellValue(labelCell, labelText, "infoHeader", "center");
        setCellValue(valueCell, value, "value", "center");
      });

      // Data grid space
      // worksheet.getRow(20).height = 10; // Space before grid

      const quarterMonths = {
        q1: [ "January", "February", "March" ],
        q2: [ "April", "May", "June" ],
        q3: [ "July", "August", "September" ],
        q4: [ "October", "November", "December" ],
        h1: [ "January", "February", "March", "April", "May", "June" ],
        h2: [ "July", "August", "September", "October", "November", "December" ],
      };

      const ensureMonthsExist = (months) => {
        const availableMonths = Object.keys(qtyOne);

        if (availableMonths.length === 0) {
          throw new Error(
            "No reference data available to construct missing months."
          );
        }

        const referenceMonth = availableMonths[ 0 ];

        const createEmptyMonth = () => {
          const newMonth = {};
          Object.keys(qtyOne[ referenceMonth ]).forEach((category) => {
            newMonth[ category ] = {};
            Object.keys(qtyOne[ referenceMonth ][ category ]).forEach((key) => {
              newMonth[ category ][ key ] = 0;
            });
          });
          return newMonth;
        };

        months.forEach((month) => {
          if (!availableMonths.includes(month)) {
            qtyOne[ month ] = createEmptyMonth();
          }
        });
      };

      const calculateQuarter = (months) => {
        const quarter = {};
        const { SECTION_ORDER } = STYLES;

        ensureMonthsExist(months);

        const allCategoryKeys = new Set([ ...SECTION_ORDER ]);
        months.forEach((month) => {
          const monthData = qtyOne[ month ];
          Object.keys(monthData).forEach((category) =>
            allCategoryKeys.add(category)
          );
        });

        months.forEach((month) => {
          const monthData = qtyOne[ month ];

          allCategoryKeys.forEach((category) => {
            if (monthData[ category ]) {
              quarter[ category ] = quarter[ category ] || {};

              Object.entries(monthData[ category ]).forEach(([ key, value ]) => {
                quarter[ category ][ key ] = (quarter[ category ][ key ] || 0) + value;
              });
            }
          });
        });

        return quarter;
      };

      const displayMonthHeaders = (monthData) => {
        const columnLetters = [ ...Array(17) ].map(
          (_, i) => String.fromCharCode("C".charCodeAt(0) + i) // Start from C instead of B
        );

        Object.keys(monthData).forEach((month, index) => {
          if (index < columnLetters.length) {
            const cell = worksheet.getCell(`${columnLetters[ index ]}18`);
            cell.value = month.toUpperCase();
            applyStyle(cell, "gridHeader");
            cell.alignment = { horizontal: "center", vertical: "middle" };
          }
        });
      };

      const populateReportData = (reportData) => {
        const { HIGHLIGHT_KEYS, SECTION_ORDER } = STYLES;
        let rowIndex = 19; // Start after headers

        const firstMonth = Object.keys(reportData)[ 0 ];
        const firstMonthData = reportData[ firstMonth ];

        const processedSections = new Set();

        // Create a map to track row indices for each section
        const sectionRowIndices = {};

        const processSection = (section) => {
          if (!firstMonthData[ section ] || processedSections.has(section)) return;

          const sectionCell = worksheet.getCell(`B${rowIndex}`); // Changed from A to B

          // Custom label logic
          let sectionLabel = section.replace(/[_-]/g, " ");
          if (section === "Part_B_S_&_U_Distribution") {
            sectionLabel = "Part B: S U Distribution";
          }
          if (section === "S_&_U_Return") {
            sectionLabel = `S & U Return (${customerdata?.customerinner?.state})`;
          }

          sectionCell.value = sectionLabel;
          applyStyle(sectionCell, "gridSubheader"); // Changed to match image
          sectionCell.alignment = { vertical: "middle" };

          worksheet.mergeCells(`B${rowIndex}:S${rowIndex}`); // Changed from A-R to B-S
          rowIndex++;

          // Store the starting row index for this section
          sectionRowIndices[ section ] = rowIndex;

          let indexCounter = 1; // Initialize counter for this section

          Object.keys(firstMonthData[ section ]).forEach((key) => {
            const labelCell = worksheet.getCell(`B${rowIndex}`); // Changed from A to B

            // Custom label mapping for specific sections and keys
            let customLabel = key.replace(/[_-]/g, " ");

            // Custom labels for Part_B_S_&_U_Distribution section
            if (section === "Part_B_S_&_U_Distribution") {
              if (key === "State") {
                customLabel = `State (${customerdata?.customerinner?.state})`;
              } else if (key === "County") {
                customLabel = `County (${customerdata?.customerinner?.county})`;
              }
            }

            // Custom labels for Vendor_Compensation section
            if (section === "Vendor_Compensation") {
              if (key === "Non_MF_Sales_1st") {
                customLabel = "Non MF Sales (1st 3000)";
              } else if (key === "Non_MF_Sales_Aft") {
                customLabel = "Non MF Sales (Aft 3000)";
              }
            }

            labelCell.value = customLabel;

            // Only add index number if in the S_&_U_Return section
            if (section === "S_&_U_Return") {
              const indexCell = worksheet.getCell(`A${rowIndex}`);

              // Use specific index numbers for S_&_U_Return section
              const specificIndexNumbers = [ 1, 2, 3, 4, 7, 8 ];
              // Get the index within this section (0-based)
              const keyIndex = Object.keys(firstMonthData[ section ]).indexOf(key);

              // If this key has a specified index in our list, use it, otherwise leave blank
              if (keyIndex >= 0 && keyIndex < specificIndexNumbers.length) {
                indexCell.value = specificIndexNumbers[ keyIndex ];
                // Apply style but don't format as currency
                applyStyle(
                  indexCell,
                  "alternate",
                  rowIndex % 2 === 0 ? "even" : "odd"
                );
                indexCell.alignment = { horizontal: "center", vertical: "middle" };
                // Ensure the index is not formatted as currency
                indexCell.numFmt = "0";
              }
            }

            indexCounter++; // Still increment counter for all sections

            if (HIGHLIGHT_KEYS.totalRows.has(key)) {
              applyStyle(labelCell, "total");
            } else if (HIGHLIGHT_KEYS.important.has(key)) {
              applyStyle(labelCell, "highlight");
            } else {
              applyStyle(
                labelCell,
                "alternate",
                rowIndex % 2 === 0 ? "even" : "odd"
              );
            }

            Object.entries(reportData).forEach(([ month, monthData ], colIndex) => {
              const cell = worksheet.getCell(rowIndex, colIndex + 3); // Changed from colIndex+2 to colIndex+3
              const value = monthData[ section ]?.[ key ] || 0;

              cell.value = value;

              // Apply special highlight for NET_SALES values
              if (key === "NET_SALES") {
                applyStyle(cell, "netSalesHighlight", "right");
              } else if (month.includes("Total") || month.includes("Exempt_Trans")) {
                applyStyle(cell, "total", "right");
              } else {
                applyStyle(
                  cell,
                  "alternate",
                  rowIndex % 2 === 0 ? "even" : "odd"
                );
              }

              cell.alignment = { horizontal: "right", vertical: "middle" };

              if (typeof value === "number" || !isNaN(parseFloat(value))) {
                cell.numFmt = '"$ "#,##0.00';
              }
            });

            rowIndex++;
          });

          worksheet.getRow(rowIndex).height = 5;
          rowIndex++;

          processedSections.add(section);
        };

        SECTION_ORDER.forEach((section) => processSection(section));

        Object.keys(firstMonthData).forEach((section) => {
          if (!processedSections.has(section)) {
            processSection(section);
          }
        });
      };

      const processQuarterData = (filter) => {
        const allMonths = Object.values(quarterMonths).flat();
        let orderedData = {};

        // Process specific quarter, half-year, or full year
        if (filter === "h1") {
          const months = quarterMonths.h1;
          ensureMonthsExist(months);

          // Calculate Q1 and Q2 totals
          qtyOne[ "Q1 Total" ] = calculateQuarter(quarterMonths.q1);
          qtyOne[ "Q2 Total" ] = calculateQuarter(quarterMonths.q2);
          qtyOne[ "H1 Total" ] = calculateQuarter(months);

          [
            ...quarterMonths.q1,
            "Q1 Total",
            ...quarterMonths.q2,
            "Q2 Total",
            "H1 Total",
          ].forEach((key) => {
            orderedData[ key ] = qtyOne[ key ];
          });
        } else if (filter === "h2") {
          const months = quarterMonths.h2;
          ensureMonthsExist(months);

          // Calculate Q3 and Q4 totals
          qtyOne[ "Q3 Total" ] = calculateQuarter(quarterMonths.q3);
          qtyOne[ "Q4 Total" ] = calculateQuarter(quarterMonths.q4);
          qtyOne[ "H2 Total" ] = calculateQuarter(months);

          [
            ...quarterMonths.q3,
            "Q3 Total",
            ...quarterMonths.q4,
            "Q4 Total",
            "H2 Total",
          ].forEach((key) => {
            orderedData[ key ] = qtyOne[ key ];
          });
        } else if (quarterMonths[ filter ]) {
          const months = quarterMonths[ filter ];
          ensureMonthsExist(months);

          // Add total for selected quarter
          qtyOne[ `${filter.toUpperCase()} Total` ] = calculateQuarter(months);

          months.forEach((month) => {
            orderedData[ month ] = qtyOne[ month ];
          });
          orderedData[ `${filter.toUpperCase()} Total` ] =
            qtyOne[ `${filter.toUpperCase()} Total` ];
        } else {
          // Full year processing
          ensureMonthsExist(allMonths);

          // Calculate all sub-totals and totals
          qtyOne[ "Q1 Total" ] = calculateQuarter(quarterMonths.q1);
          qtyOne[ "Q2 Total" ] = calculateQuarter(quarterMonths.q2);
          qtyOne[ "H1 Total" ] = calculateQuarter(quarterMonths.h1);

          qtyOne[ "Q3 Total" ] = calculateQuarter(quarterMonths.q3);
          qtyOne[ "Q4 Total" ] = calculateQuarter(quarterMonths.q4);
          qtyOne[ "H2 Total" ] = calculateQuarter(quarterMonths.h2);

          qtyOne[ "Total" ] = calculateQuarter([
            ...quarterMonths.h1,
            ...quarterMonths.h2,
          ]);

          // Order data: months → Q totals → H totals → Total
          [
            ...quarterMonths.q1,
            "Q1 Total",
            ...quarterMonths.q2,
            "Q2 Total",
            // "H1 Total",
            ...quarterMonths.q3,
            "Q3 Total",
            ...quarterMonths.q4,
            "Q4 Total",
            // "H2 Total",
            "Total",
          ].forEach((key) => {
            if (qtyOne[ key ]) {
              orderedData[ key ] = qtyOne[ key ];
            }
          });
        }

        // Display headers and populate worksheet
        displayMonthHeaders(orderedData);
        populateReportData(orderedData);
      };

      const filterType = data?.filter_type?.toLowerCase() || "annual";

      processQuarterData(filterType);

      if (customerdata?.business_type === "Tennessee") {
        const applyBatchStyling = (
          ranges,
          color,
          isBold = false,
          fontColor = null
        ) => {
          ranges.forEach((range) => {
            const [ start, end ] = Array.isArray(range) ? range : [ range, range ];
            for (let rowIndex = start; rowIndex <= end; rowIndex++) {
              worksheet
                .getRow(rowIndex)
                .eachCell({ includeEmpty: false }, (cell) => {
                  cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: color },
                  };

                  if (isBold || fontColor) {
                    cell.font = {
                      ...cell.font,
                      bold: isBold,
                      color: fontColor ? { argb: fontColor } : undefined,
                    };
                  }
                });
            }
          });
        };

        applyBatchStyling(
          [
            [ 17, 45 ],
            [ 48, 67 ],
            [ 70, 75 ],
            [ 78, 85 ],
            [ 88, 93 ],
            [ 96, 111 ],
            [ 115, 117 ],
            [ 119, 119 ],
            [ 121, 122 ],
            [ 124, 124 ],
            [ 126, 126 ],
          ],
          "ECECEC"
        ); // Gray

        applyBatchStyling([ 114, 118, 120, 123, 125, 127 ], "FFFF00", true); // Yellow + Bold
        applyBatchStyling([ 128 ], "0000FF", true, "FFFFFF"); // Blue + Bold
      }

      // Apply consistent font styling across all cells
      worksheet.eachRow({ includeEmpty: false }, (row) => {
        row.eachCell({ includeEmpty: false }, (cell) => {
          if (cell.font) {
            cell.font = { ...cell.font, size: 11, name: "Calibri" };
          } else {
            cell.font = { size: 11, name: "Calibri" };
          }

          // Only apply currency format for cells in columns C-S (3-19)
          // Don't apply currency format to index numbers in column A
          const value = cell.value;
          const columnIndex = cell._column.number;
          if (
            (columnIndex >= 3 && // Columns C-S only
              typeof value === "number") ||
            (typeof value === "string" && !isNaN(parseFloat(value)))
          ) {
            cell.numFmt = '"$ "#,##0.00';
          }
        });
       
      });
      function styleRowsByHeaderKeywords(worksheet) {
        const keywords = ["total", "net", "exempt", "gross","exampt"]; // lowercase
        const targetCols = ["B","F", "J", "N", "R", "S"]; // Columns to style
      
        worksheet.eachRow((row, rowNumber) => {
          // Skip specific row numbers
          if (rowNumber === 10 || rowNumber === 17 || rowNumber === 18 || rowNumber === 19) return;
      
          // Skip rows where first cell (column A) is a non-empty string
          const firstCell = row.getCell(1); // Column A
          if (firstCell && typeof firstCell.value === "string" && firstCell.address.startsWith("A")) return;
      
          let shouldStyle = false;
          let isCalculationTotal = false;
      
          row.eachCell((cell) => {
            if (cell.value && typeof cell.value === "string") {
              const text = cell.value.trim().toLowerCase();
      
              if (text.includes("calculation total")) {
                isCalculationTotal = true;
              } else if (keywords.some((kw) => text.includes(kw))) {
                shouldStyle = true;
              }
            }
          });
      
          if (isCalculationTotal) {
            row.eachCell((cell) => {
              cell.font = { ...cell.font, bold: true };
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "4472C4" }, // Dark blue background
              };
            });
          } else if (shouldStyle) {
            row.eachCell((cell) => {
              const colLetter = cell.address.replace(/[0-9]/g, ""); // Extract column letter (e.g., 'F')
              if (targetCols.includes(colLetter)) {
                cell.font = { ...cell.font, bold: true };
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "E2EFDA" }, // Light green background
                };
              }
            });
          }
        });
      }
      
      
      
      
      
      // Apply bold to total rows
      const { HIGHLIGHT_KEYS } = STYLES;
      worksheet.eachRow({ includeEmpty: false }, (row, rowIndex) => {
        const labelCell = row.getCell(2); // Changed from 1 to 2 (column B)
        if (labelCell.value && typeof labelCell.value === "string") {
          const label = labelCell.value.toString();

          if (HIGHLIGHT_KEYS.totalRows.has(label)) {
            row.eachCell({ includeEmpty: false }, (cell) => {
              cell.font = { ...cell.font, bold: true };
            });
          }
        }
      });

      const lastRow = worksheet.lastRow.number + 3;
      setCellValue(
        `B${lastRow}`,
        `Report generated on: ${new Date().toLocaleDateString()}`,
        "normal",
        "left"
      );
      worksheet.mergeCells(`B${lastRow}:S${lastRow}`); // Changed from A-R to B-S
      // const row15 = worksheet.getRow(19);
      // row15.values = [];
      styleRowsByHeaderKeywords(worksheet)
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([ buffer ], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const filterLabel =
        filterType === "annual" ? "Annual" : filterType.toUpperCase();

      saveAs(
        blob,
        `${customerdata?.dba_name} - ${filterLabel} - ${new Date().getTime()}`
      );
    } catch (error) {
      console.error("Error generating Excel report:", error);
      throw new Error(`Failed to generate Excel report: ${error.message}`);
    }
  };


  const taxTypeData = [
    { label: "Gross Non fule", value: "#7593CE" },
    { label: "High", value: "#BAD9F8" },
    { label: "Low", value: "#F7FBFC" },
    { label: "Gas", value: "#FFE5E4" },
    { label: "Diesel", value: "#F8CACA" },
    { label: "Non Taxable", value: "#7593CE" },
    { label: "Other", value: "#BAD9F8" },
    { label: "GA Tax", value: "#F7FBFC" },
    { label: "Hotel Occupancy", value: "#FFE5E4" },
    { label: "Room Tax", value: "#F8CACA" },
    { label: "Adjustment", value: "#7593CE" },
    { label: "Custom", value: "#7593CE" },
    { label: "Non Food", value: "#BAD9F8" },
    { label: "Food Sales", value: "#F7FBFC" },
    { label: "CBD Sales", value: "#FFE5E4" },
    { label: "Non Taxable Sales", value: "#F8CACA" },
    { label: "Lotto & Non Sales", value: "#7593CE" },
    { label: "Other Misc Info", value: "#BAD9F8" },
    { label: "Calculation Total", value: "#F7FBFC" },
    { label: "Par B S U Distribution", value: "#FFE5E4" },
    { label: "S & U Return", value: "#F8CACA" },
    { label: "Vendor Compensation", value: "#7593CE" },
  ];
  return (
    <React.Fragment>
      <Formik
        enableReinitialize
        initialValues={{
          // ------customer details------
          customer_file_no: id ? singleData?.customer_file_no : "",
          company_name: id ? singleData?.company_name : "",
          dba_name: id ? singleData?.dba_name : "",
          address: id ? singleData?.address : "",
          state: id ? singleData?.state : "",
          city: id ? singleData?.city : "",
          s_and_u_number: id ? singleData?.s_and_u_number : "",
          mobile_no: id ? singleData?.mobile_no : "",

          // ------tax composition details------
          state_tax: id ? singleData?.state_tax : "",
          county_tax: id ? singleData?.county_tax : "",
          total_ga_tax: id ? singleData?.total_ga_tax : "",
          vendor_comp_above: id ? singleData?.vendor_comp_above : 0,
          vendor_comp_below: id ? singleData?.vendor_comp_below : 0,

          off_road_fuel: id ? singleData?.off_road_fuel : 0,
          on_road_fuel: id ? singleData?.on_road_fuel : 0,
          local_tax: id ? singleData?.local_tax : 0,
          cbd_sales: id ? singleData?.cbd_sales : 0,
          non_food: id ? singleData?.non_food : 0,
          food_sales: id ? singleData?.food_sales : 0,

          //--------bank details---------
          website: id ? singleData?.website : "",
          username: id ? singleData?.username : "",
          password: id ? singleData?.password : "",
          bank_name: id ? singleData?.bank_name : "",
          bank_branch: id ? singleData?.bank_branch : "",
          bank_account_no: id ? singleData?.bank_account_no : "",
          routing_number: id ? singleData?.routing_number : "",
          bank_micr_code: id ? singleData?.bank_micr_code : "",
          account_holder_name: id ? singleData?.account_holder_name : "",

          year: "",
          month: "",
          filter_type: "",
          //--------tax-heads-details---------
          tax_head: "",
        }}
        validationSchema={
          filter == "filter"
            ? validationSchemaFilterModal
            : validationSchemaDisapproveModal
        }
        onSubmit={(values) => {
          const FinalValue = {
            tax_head: values.tax_head,
            submit_for_review: 1,
            year: values.year,
            month: values.month,
            state_tax: values?.state_tax,
            county_tax: values?.county_tax,
            total_ga_tax:
              parseFloat(values?.state_tax) + parseFloat(values?.county_tax),
            vendor_comp_above: values.vendor_comp_above,
            vendor_comp_below: values.vendor_comp_below,
            off_road_fuel: values?.off_road_fuel,
            on_road_fuel: values?.on_road_fuel,
            local_tax: values?.local_tax,
            cbd_sales: values?.cbd_sales,
            non_food: values?.non_food,
            food_sales: values?.food_sales,
          };

          const FilterValue = {
            year: values.year,
            filter_type: values.filter_type,
          };

          filter == "filter"
            ? handleDownload(FilterValue)
            : handleSubmit(FinalValue);
        }}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form style={{ width: "100%", margin: "auto" }}>
            <div className="grid-container">
              <div className="grid-row grid-gap">
                <div className="grid-col-12">
                  <div className="grid-container padding-top-2">
                    <div className="grid-row grid-gap-1">
                      {singleData?.reason && (
                        <div className="grid-col-12 margin-bottom-2">
                          <div
                            className="usa-alert usa-alert--error"
                            role="alert"
                          >
                            <div className="usa-alert__body">
                              <p className="usa-alert__text">
                                {singleData?.reason}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="grid-col-12 padding-0 margin-0">
                        <div className="grid-row grid-gap-1 margin-0 padding-0">
                          <div
                            className="padding-0 margin-0"
                            style={{ width: "60%" }}
                          >
                            <p className="text-bold margin-0">
                              Company Name: {singleData?.company_name}
                            </p>
                          </div>
                          <div
                            className="padding-0 margin-0"
                            style={{ width: "40%" }}
                          >
                            <p className="text-bold margin-0">
                              DBA Name: {singleData?.dba_name}
                            </p>
                          </div>

                          <div
                            className="padding-0 margin-0"
                            style={{ width: "50%" }}
                          >
                            <label
                              className="usa-label margin-0"
                              htmlFor="year"
                            >
                              Select Year
                              <span className="usa-label--required">*</span>
                            </label>
                            <Field
                              name="year"
                              component={CustomSelect}
                              options={yearOptions}
                              onChange={(e) => {
                                setFieldValue("year", e.value);
                                const data = singleData?.files[e.value];
                                setMonthByYers(data);
                              }}
                            />
                            {errors.year && touched.year && (
                              <span className="usa-error-message margin-0">
                                {errors.year}
                              </span>
                            )}
                          </div>

                          {filter === "filter" ? (
                            <div
                              className="padding-0 margin-0"
                              style={{ width: "50%" }}
                            >
                              <label
                                className="usa-label margin-0"
                                htmlFor="filter_type"
                              >
                                Filter Type
                                <span className="usa-label--required">*</span>
                              </label>
                              <Field
                                name="filter_type"
                                component={CustomSelect}
                                options={filterOptions}
                              />
                              {errors.filter_type && touched.filter_type && (
                                <span className="usa-error-message margin-0">
                                  {errors.filter_type}
                                </span>
                              )}
                            </div>
                          ) : (
                            <div
                              className="padding-0 margin-0"
                              style={{ width: "50%" }}
                            >
                              <label
                                className="usa-label margin-0"
                                htmlFor="month"
                              >
                                Select Month
                                <span className="usa-label--required">*</span>
                              </label>
                              <Field
                                disabled={!values.year}
                                name="month"
                                component={CustomSelect}
                                options={monthOptions}
                                onChange={(e) => {
                                  setFieldValue("month", e.value);
                                  const selctedMonth = monthByYear?.find(
                                    (itme) => itme?.month === e.label
                                  );
                                  setMonthSingleFileDate(selctedMonth);
                                  selctedMonth
                                    ? setFieldValue(
                                        "tax_head",
                                        selctedMonth?.tax_head
                                      )
                                    : setFieldValue(
                                        "tax_head",
                                        singleData?.empty_tax_heads
                                      );
                                }}
                              />
                              {errors.month && touched.month && (
                                <span className="usa-error-message margin-0">
                                  {errors.month}
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      {filter != "filter" && (
                        <div>
                          <div className="tax-cards-container">
                            {/* Main Tax Cards */}
                            <div className="main-tax-cards">
                              <div
                                className="tax-card-hover"
                                onClick={() => {
                                  setCommanFiled("state_tax");
                                  setCommanFiledLabel("State Tax");
                                  setCommanFiledModal(true);
                                }}
                              >
                                <div className="tax-card-gradient">
                                  <h3 className="tax-card-title">
                                    State Tax &nbsp;{" "}
                                    <span style={{ fontSize: "15px" }}>
                                      {values.state_tax || 0}%
                                    </span>
                                  </h3>
                                </div>
                              </div>

                              <div
                                className="clickable-card"
                                onClick={() => {
                                  setCommanFiled("county_tax");
                                  setCommanFiledLabel("County Tax");
                                  setCommanFiledModal(true);
                                }}
                              >
                                <div className="tax-card-gradient">
                                  <h3 className="tax-card-title ">
                                    County Tax &nbsp;{" "}
                                    <span style={{ fontSize: "15px" }}>
                                      {values?.county_tax || 0}%
                                    </span>
                                  </h3>
                                </div>
                              </div>

                              <div>
                                <div className="tax-card-gradient">
                                  <h3 className="tax-card-title ">
                                    Total Tax &nbsp;
                                    <span style={{ fontSize: "15px" }}>
                                      {parseFloat(values?.state_tax || 0) +
                                        parseFloat(values?.county_tax || 0)}
                                      %
                                    </span>
                                  </h3>
                                </div>
                              </div>
                            </div>

                            {/* Secondary Tax Cards */}
                            <div className="secondary-tax-cards">
                              <div
                                className="tax-card"
                                onClick={() => {
                                  setCommanFiled("food_sales");
                                  setCommanFiledLabel("Food Sales");
                                  setCommanFiledModal(true);
                                }}
                              >
                                <div className="tax-card-inner">
                                  <h4 className="tax-card-title">
                                    Food Sales &nbsp;{" "}
                                    <span className="tax-card-value">
                                      {values.food_sales || 0}%
                                    </span>
                                  </h4>
                                </div>
                              </div>

                              <div
                                className="tax-card"
                                onClick={() => {
                                  setCommanFiled("non_food");
                                  setCommanFiledLabel("Non-Food");
                                  setCommanFiledModal(true);
                                }}
                              >
                                <div className="tax-card-inner">
                                  <h4 className="tax-card-title">
                                    Non-Food &nbsp;{" "}
                                    <span className="tax-card-value">
                                      {values.non_food || 0}%
                                    </span>
                                  </h4>
                                </div>
                              </div>

                              <div
                                className="tax-card"
                                onClick={() => {
                                  setCommanFiled("cbd_sales");
                                  setCommanFiledLabel("CBD Sales");
                                  setCommanFiledModal(true);
                                }}
                              >
                                <div className="tax-card-inner">
                                  <h4 className="tax-card-title">
                                    CBD Sales &nbsp;{" "}
                                    <span className="tax-card-value">
                                      {values.cbd_sales || 0}%
                                    </span>
                                  </h4>
                                </div>
                              </div>

                              <div
                                className="tax-card"
                                onClick={() => {
                                  setCommanFiled("local_tax");
                                  setCommanFiledLabel("Local Sales");
                                  setCommanFiledModal(true);
                                }}
                              >
                                <div className="tax-card-inner">
                                  <h4 className="tax-card-title">
                                    Local Sales &nbsp;{" "}
                                    <span className="tax-card-value">
                                      {values.local_tax || 0}%
                                    </span>
                                  </h4>
                                </div>
                              </div>
                            </div>

                            {/* Vendor and Fuel Tax Cards */}
                            <div className="vendor-fuel-cards">
                              <div
                                className="fuel-card"
                                onClick={() => {
                                  setCommanFiled("vendor_comp_above");
                                  setCommanFiledLabel(
                                    `Vendor Comp (Below $ 3000)`
                                  );
                                  setCommanFiledModal(true);
                                }}
                              >
                                <div className="fuel-card-inner">
                                  <h4 className="fuel-card-title">
                                    Vendor Comp (Below $3000) &nbsp; <br />
                                    <span className="fuel-card-value">
                                      {values.vendor_comp_above || 0}%
                                    </span>
                                  </h4>
                                </div>
                              </div>

                              <div
                                className="fuel-card"
                                onClick={() => {
                                  setCommanFiled("vendor_comp_below");
                                  setCommanFiledLabel(
                                    `Vendor Comp (Above $ 3000)`
                                  );
                                  setCommanFiledModal(true);
                                }}
                              >
                                <div className="fuel-card-inner">
                                  <h4 className="fuel-card-title">
                                    Vendor Comp (Above $3000) &nbsp; <br />
                                    <span className="fuel-card-value">
                                      {values.vendor_comp_below || 0}%
                                    </span>
                                  </h4>
                                </div>
                              </div>

                              <div
                                className="fuel-card"
                                onClick={() => {
                                  setCommanFiled("on_road_fuel");
                                  setCommanFiledLabel(`On Road Fuel`);
                                  setCommanFiledModal(true);
                                }}
                              >
                                <div className="fuel-card-red">
                                  <h4 className="fuel-card-title">
                                    On Road Fuel &nbsp;{" "}
                                    <span className="fuel-card-value">
                                      {values.on_road_fuel || 0}%
                                    </span>
                                  </h4>
                                </div>
                              </div>

                              <div
                                className="fuel-card"
                                onClick={() => {
                                  setCommanFiled("off_road_fuel");
                                  setCommanFiledLabel(`Off Road Fuel`);
                                  setCommanFiledModal(true);
                                }}
                              >
                                <div className="fuel-card-red">
                                  <h4 className="fuel-card-title">
                                    Off Road Fuel &nbsp;{" "}
                                    <span className="fuel-card-value">
                                      {values.off_road_fuel || 0}%
                                    </span>
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Tax Heads Table */}
                          <div className="tax-table-wrapper">
                            <table className="tax-table">
                              <thead>
                                <tr>
                                  <th className="tax-table-header">
                                    Tax Head Type
                                  </th>
                                  <th className="tax-table-header">Tax Head</th>
                                  <th className="tax-table-header">Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {values?.tax_head &&
                                  Object.keys(values?.tax_head).map(
                                    (category, categoryIndex) => (
                                      <React.Fragment key={categoryIndex}>
                                        {values.tax_head[category].map(
                                          (item, itemIndex) => {
                                            const bgColor = (() => {
                                              // Color mapping for categories
                                              const colorMap = {
                                                sales_tax: "#e3f2fd",
                                                excise_tax: "#e8f5e9",
                                                income_tax: "#fff3e0",
                                                property_tax: "#f3e5f5",
                                              };

                                              const label = category.replace(
                                                /[_-]/g,
                                                " "
                                              );
                                              const match = taxTypeData.find(
                                                (item) => item.label === label
                                              );
                                              return match
                                                ? match.value
                                                : colorMap[category] ||
                                                    "#f5f5f5";
                                            })();

                                            return (
                                              <tr
                                                key={itemIndex}
                                                className={
                                                  itemIndex % 2 === 0
                                                    ? "even-row"
                                                    : "odd-row"
                                                }
                                              >
                                                {itemIndex === 0 && (
                                                  <td
                                                    rowSpan={
                                                      values.tax_head[category]
                                                        .length
                                                    }
                                                    className="category-cell"
                                                    style={{
                                                      backgroundColor: bgColor,
                                                    }}
                                                  >
                                                    {category
                                                      .replace(/[_-]/g, " ")
                                                      .replace(/\b\w/g, (c) =>
                                                        c.toUpperCase()
                                                      )}
                                                  </td>
                                                )}
                                                <td className="tax-head-cell">
                                                  {formatString(
                                                    Object.keys(item)[0]
                                                  )}
                                                </td>
                                                <td className="amount-cell">
                                                  <div className="amount-wrapper">
                                                    {/* <span className="currency-symbol">
                                                      $
                                                    </span> */}
                                                    <Field
                                                      name={`tax_head.${category}[${itemIndex}].${
                                                        Object.keys(item)[0]
                                                      }`}
                                                    >
                                                      {({ field, form }) => (
                                                        <CurrencyFormat
                                                          {...field}
                                                          thousandSeparator={
                                                            true
                                                          }
                                                          decimalScale={2}
                                                          fixedDecimalScale={
                                                            true
                                                          }
                                                          allowNegative={true}
                                                          prefix="$" // <-- Add this line
                                                          onValueChange={({
                                                            value,
                                                          }) => {
                                                            setFieldValue(
                                                              field.name,
                                                              value
                                                            );
                                                          }}
                                                          value={
                                                            field.value || ""
                                                          }
                                                          className="currency-input"
                                                          placeholder="$0.00"
                                                        />
                                                      )}
                                                    </Field>
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                      </React.Fragment>
                                    )
                                  )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="form-footer">
                      {filter != "filter" && (
                        <button
                          type="submit"
                          className="usa-button"
                          disabled={
                            filter !== "filter"
                              ? userType === "CPA"
                                ? false
                                : monthSingleFileData?.file_status ===
                                  "data_approved"
                                ? true
                                : false
                              : false
                          }
                        >
                          {filter == "filter" ? "Download" : "Approve data"}
                        </button>
                      )}

                      {isDwonload && (
                        <button
                          type="button"
                          className="btn btn-submit"
                          onClick={() => {
                            const FilterValue = {
                              year: values.year,
                              filter_type: values.filter_type,
                            };

                            if (!submitLoader) {
                              handleDownload2(FilterValue);
                            }
                          }}
                        >
                          {submitLoader ? "Loading" : "Download"}
                        </button>
                      )}

                      <button
                        type="button"
                        className="btn btn-cancel"
                        onClick={onClose}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {commanFiledModal && (
              <CommonModal
                open={commanFiledModal}
                onClose={() => {
                  setCommanFiledModal(false);
                  setCommanFiled("");
                  setCommanFiledLabel("");
                  setFieldValue(`newFiled`, "");
                }}
                title={`Update ${commanFiledLabel}`}
              >
                <div className="padding-top-2">
                  <div className="padding-bottom-1">
                    Old {commanFiledLabel} Value: {singleData[commanFiled]} %
                  </div>
                  <Field
                    id={commanFiled}
                    className="usa-input"
                    name="newFiled"
                    type="number"
                    placeholder={`Enter New ${commanFiledLabel}`}
                    style={{ padding: "8px 15px", textAlign: "right" }}
                    min={0}
                    max={100}
                    step={0.01}
                  />

                  <div className="text-right padding-top-1">
                    <button
                      type="button"
                      className="usa-button"
                      onClick={() => {
                        setFieldValue(`${commanFiled}`, values.newFiled);
                        setCommanFiledModal(false);
                        setCommanFiled("");
                        setCommanFiledLabel("");
                        setFieldValue(
                          `total_ga_tax`,
                          parseFloat(values?.state_tax) +
                            parseFloat(values?.county_tax)
                        );
                        setFieldValue(`newFiled`, "");
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </CommonModal>
            )}
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}
